import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe86cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "inputField flex-grow" }
const _hoisted_4 = { class: "float-left" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-reset" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "float-right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear-both" }, null, -1))

import { useGlobalStore } from '@/stores/GlobalStore'
import { BryntumGrid } from "@bryntum/grid-vue-3";
import {Menu, Store} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import {PopupType } from '@/utilities/enums/Enums';
import { $t } from "@/utilities/i18n/config";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {useI18n} from "vue-i18n";
import moment from 'moment';
import {CoupledSafetyInstructionActionType, ErrorLocationType, TableType} from "@/utilities/enums/Enums";
import dialog from "@/dialog";
import SignalRSender from "@/utilities/signalR/signalRSender";
import {checkboxColumnConfig} from "@/AppConfig";
import {HubNotification} from "@/models/HubNotification";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {MiscService} from "@/utilities/services/entities/MiscService";
import { WebhookService } from "@/utilities/services/entities/WebhookService";


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const service = new WebhookService();
const loadfailedAnAbDelivery = async () => {
    const listsfailedAnAbDelivery = (await service.failedAnAbDelivery()) as any;
    await sendFailedAnAbDelivery(listsfailedAnAbDelivery);
    console.log(listsfailedAnAbDelivery);
    await setGridData();
    };
const sendFailedAnAbDelivery = async (listResponse:any) => {
    const resp = (await service.sendFailedAnAbDelivery(listResponse)) as any;
    console.log(resp);
    await setGridData();
};
const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();

const miscService = new MiscService();

const selectedNotifs = ref<Array<HubNotification>>([]);

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedNotifs.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t('global.delete'))
      .cancelText(t('global.cancel'))
      .confirm(t('notifications.confirmDeletionMulti', {count:selectedNotifs.value.length}));

  if (answer) {
    try {
      for (const notif of selectedNotifs.value) {
        if (!hasNoSafetyInstruction(notif)) {
          // CAUTION changed from declined to accept to simplyfy and clarify work flwo and seperate SHs from Notifications
          await SignalRSender.actOnCoupledSecurityInstruction(notif.id, CoupledSafetyInstructionActionType.accept)
        } else {
          SignalRSender.discardNotification(notif.id)
        }

        globalStore.notifications = globalStore.notifications.filter(n => n.id !== notif.id);
        gridStore.applyChangeset({removed:[{id:notif.id}]});
      }
    }
    catch (e) {
      console.log("notif removal failed:", e)
    }

    globalStore.showSuccess(t("global.deleted"));
  }
};

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
  autoHeight : true,
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      {
        id:'notificationText',
        field : 'notificationText',
        text: t('notifications.text'),
        flex   : 1,
        sortable: false,
        autoHeight: true,
        htmlEncode  : false,
        renderer({ record }) {
					return record.data.text;
        },
      },
      {
        id:'type',
        field : 'type',
        text: t('notifications.type'),
        width   : 120,
        sortable: true,
        type: 'template',
          template: ({ record }) => {
              const tp = record.data.type === "failedanab" ? "alert" : record.data.type;
              const val = record.data.type === "failedanab" ? "Ereignisfehler" : record.data.type;
          return "<div class='notificatioType'><span class='"+tp+"'>"+val+"</span></div>";
         },
       },
       {
              id: 'hasDescription',
           field: 'hasDescription',
           text: t('info'),
              width: 120,
              sortable: true,
              type: 'template',
              template: ({ record }) => {
                  return record.data.hasDescription && record.data.type?.toLowerCase().includes("failedanab") ? `<div class='gridRowButton'><span class='icon-info'></span></div>` : "";
              },
       },
       {
        id:'date',
        field : 'date',
        text: t('notifications.date'),
        width: 200,
        sortable: true,
        type: 'template',
        template: ({ record }) => {
          return moment(record.data.date).format('DD.MM.YYYY HH:mm');
        },
       },
			{
				id: 'infoButton',
				field: 'infoButton',
				text: "",
				width: 50,
				minWidth: 50,
				sortable: false,
				type: "template",
				template: ({record}) => {
					if (record.data.safetyInstruction !== null) {
						return `<div class='gridRowButton'><span class='icon-sicherheitshinweis'></span></div>`;
					} else {
						return;
					}
				},
			},
      {
        id:'menu',
        text  : '',
        width   : 36,
        type  : 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [
          {
            type   : 'button',
            width: 36,
            icon   : 'icon-kontext_horizontal',
            onAction : ({ source: btn }) => {
              const menu = menuFactory(btn.cellInfo.record.data);
              menu.alignTo({ target: btn })
              menu.show();
            }
          }
        ]
      }
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.notification], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedNotifs.value = selectedNotifs.value.concat(event.selected.map(nr => nr.data))
      selectedNotifs.value = selectedNotifs.value.filter(n => !event.deselected.map(nr => nr.data).some(nr => n?.id === nr?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    async cellClick({column, record}) {
        if (column.data.field === 'hasDescription') {
            if (record.data.hasDescription && record.data.type?.toLowerCase().includes("failedanab")) {
                try {
                    // prefer a dedicated description property, fall back to payloadJson or text
                    let description = record.data.description ?? record.data.payloadJson ?? record.data.text ?? "";

                    // payloadJson sometimes is a stringified JSON with escaped newline sequences; try to pretty print if parseable
                    if (typeof description === 'string' && description.trim().startsWith("{")) {
                        try {
                            const parsed = JSON.parse(description);
                            // pretty print with indentation for readability
                            description = JSON.stringify(parsed, null, 2);
                        }
                        catch {
                            // leave raw string if parsing fails
                        }
                    }
                   
                    description = record.data;
   globalStore.openPopup({
         data: { description },
    action: setGridData,
    resetButton: false,
   title: $t("notifications.failedanabdetail"),
 type: PopupType.notificationDetails,
   validator: { $validate: async () => true } // add an empty validator since we don't need validation
           }, true);

                }
                catch (e: any) {
                    console.log("showing notification description failed:", e);
                }
            }
            return;
        }
      if (column.data.field === 'infoButton') {

        if(!hasNoSafetyInstruction(record.data)) {
          try {
            const locationNames = record.data.safetyInstruction.safetyInstructionLocations
                .map(l => l.name)
                .join(", ");

            const answer = await dialog
                .okText(t("notifications.applySafetyInstruction"))
                .cancelText(t("global.cancel"))
                .title(t("notifications.promptInformationTitle", {locationNames: locationNames}))
                .hint(t("notifications.promptInformationHint"))
                .confirm(t("notifications.promptInformationBody", {name: record.data.safetyInstruction.name, text: record.data.safetyInstruction.text}));

            if (answer) {
              await SignalRSender.actOnCoupledSecurityInstruction(record.data.id, CoupledSafetyInstructionActionType.accept);
            }
          }
          catch (e:any) {
            console.log("reading safetyInstruction from Hub message failed:", e);
          }
        }
      }
    },
  },
}
const gridConfig = reactive(useGridConfig);

const hasNoSafetyInstruction = (record) => {
  return record.safetyInstruction === null || record.safetyInstruction === undefined;
}

const menuFactory = (record) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items   : [
      {
        text   : t('notifications.showDetails'),
        cls : '',
        hidden: hasNoSafetyInstruction(record),
        onItem : async () => {
          if(hasNoSafetyInstruction(menu.record)) return;

          const locationNames = menu.record.safetyInstruction.safetyInstructionLocations
              .map(l => l.name)
              .join(", ");

          const answer = await dialog
              .okText(t("notifications.applySafetyInstruction"))
              .cancelText(t("global.cancel"))
              .title(t("notifications.promptInformationTitle", {locationNames: locationNames}))
              .hint(t("notifications.promptInformationHint"))
              .confirm(t("notifications.promptInformationBody", {name: menu.record.safetyInstruction.name, text: menu.record.safetyInstruction.text}));

          if (answer) {
            await SignalRSender.actOnCoupledSecurityInstruction(record.data.id, CoupledSafetyInstructionActionType.accept);
          }
        },
        weight : 200
        },
        {
            text: t('notifications.showDetails'),
            cls: '',
            hidden: !record.hasDescription && !(record.description || record.payloadJson),
            onItem: async () => {
                try {
                    let description = menu.record.description ?? menu.record.payloadJson ?? menu.record.text ?? "";
                    if (typeof description === 'string' && description.trim().startsWith("{")) {
                        try {
                            const parsed = JSON.parse(description);
                            description = JSON.stringify(parsed, null, 2);
                        } catch { /**/}
                    }

                    description = record;
                    globalStore.openPopup({
                        data: { description },
                        action: setGridData,
                        resetButton: false,
                        title: $t("notifications.failedanabdetail"),
                        type: PopupType.notificationDetails
                    }, true);
                }
                catch (e: any) {
                    console.log("showing notification details failed:", e);
                }
            },
            weight: 210
        },
      {
        text   : t('global.delete'),
        cls : '',
        onItem : async () => {
          const answer = await dialog
              .okText(t("global.delete"))
              .cancelText(t("global.cancel"))
              .confirm(t("notifications.confirmDeletionSingle"));

          if (answer) {
            if(!hasNoSafetyInstruction(record)){
              // CAUTION changed from declined to accept to simplyfy and clarify work flwo and seperate SHs from Notifications
              await SignalRSender.actOnCoupledSecurityInstruction(menu.record.id, CoupledSafetyInstructionActionType.accept)
            }
            else {
              SignalRSender.discardNotification(menu.record.id)
            }

            //globalStore.notifications = globalStore.notifications.filter(n => n.id !== menu.record.id);
            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            globalStore.showSuccess(t('global.deleted'));
          }
        },
        weight : 200
      }
    ]})

  menu.setRecord(record);

  return menu;
};

const setGridData = async ()=>{
  //get current backend notifs
  const notifResp = await miscService.getHubNotifications();
  if(notifResp === null || notifResp === undefined || notifResp?.statusCode !== 0){
    ErrorHandler.handleError(notifResp, ErrorLocationType.table);

    return;
  }

  // update globalStore with resp
  globalStore.notifications = notifResp.notifications;
  gridStore.setStoreData(globalStore.notifications);

  globalStore.reorderColumns(TableType[TableType.notification]);
}

onMounted(async () => {
  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
})

onBeforeUnmount(()=>{
  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('notifications.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "primary mr-2",
              disabled: !selectedNotifs.value.some(()=>true),
              onClick: deleteSelection
            }, _hoisted_7, 8, _hoisted_5),
            _createElementVNode("button", {
              class: "primary mr-2",
              onClick: loadfailedAnAbDelivery
            }, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(GridInputFilter), {
              gridStore: _unref(gridStore),
              hideFilterButton: true
            }, null, 8, ["gridStore"])
          ]),
          _hoisted_11,
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ])
    ])
  ]))
}
}

})